import { Text, TextProps } from '@rahtab/ui';
import React from 'react';

interface LabeledTextProps extends Pick<TextProps, 'color' | 'margin'> {
  label: string;
}

const LabeledText: React.FC<LabeledTextProps> = (props) => {
  const { children, color, label, margin } = props;
  return (
    <Text color="description" margin={margin}>
      {`${label}: `}
      <Text color={color} variant="cardTitle">
        {children}
      </Text>
    </Text>
  );
};

export default LabeledText;
